const displayName = function (userObj) {
	if (!userObj) return '---'
	// return userObj.firstname + ' ' + userObj.lastname.charAt(0).toUpperCase()
	return userObj.name
}

export default displayName